/* Single source of truth for all Atikxzio HMS pricing shown anywhere on the site. */

export const GST_NOTE = { en: "excl. 18% GST", hi: "18% GST अतिरिक्त" };

export const IPD_USAGE_RATE = 20;
export const FOUNDING_IPD_RATE = 15;
export const CREDIT_VALUE = 1;

export const PLANS = [
  {
    id: "clinic",
    name: "Clinic",
    monthly: 1799,
    setup: 2999,
    credits: 500,
    ipdUsage: false,
    recommended: false,
    forWhom: {
      en: "For single-doctor and multi-doctor OPD clinics.",
      hi: "सिंगल-डॉक्टर और मल्टी-डॉक्टर OPD क्लिनिक के लिए।",
    },
    features: {
      en: [
        "OPD queue & online booking",
        "Billing, GST invoices & UPI QR",
        "Patient records & QR patient cards",
        "Free clinic website",
      ],
      hi: [
        "OPD क्यू व ऑनलाइन बुकिंग",
        "बिलिंग, GST इनवॉइस व UPI QR",
        "मरीज़ों के रिकॉर्ड व QR पेशेंट कार्ड",
        "मुफ़्त क्लिनिक वेबसाइट",
      ],
    },
  },
  {
    id: "essential",
    name: "Essential",
    monthly: 4999,
    setup: 15000,
    credits: 1000,
    ipdUsage: true,
    recommended: false,
    forWhom: {
      en: "For nursing homes starting with IPD.",
      hi: "IPD शुरू कर रहे नर्सिंग होम के लिए।",
    },
    features: {
      en: [
        "Everything in Clinic",
        "IPD admissions & live bed board",
        "Nurse QR tasks & vitals",
        "Running bill & two-key discharge",
      ],
      hi: [
        "Clinic की हर सुविधा",
        "IPD एडमिशन व लाइव बेड बोर्ड",
        "नर्स QR टास्क व वाइटल्स",
        "रनिंग बिल व टू-की डिस्चार्ज",
      ],
    },
  },
  {
    id: "professional",
    name: "Professional",
    monthly: 5999,
    setup: 25000,
    credits: 1500,
    ipdUsage: true,
    recommended: true,
    forWhom: {
      en: "For hospitals that want the full system.",
      hi: "पूरा सिस्टम चाहने वाले अस्पतालों के लिए।",
    },
    features: {
      en: [
        "Everything in Essential",
        "Day Care & dialysis sessions",
        "AI prescription reading (4 reads per IPD patient per day included)",
        "Owner dashboard, approvals & audit",
        "Ward alerts & early-warning score",
      ],
      hi: [
        "Essential की हर सुविधा",
        "डे केयर व डायलिसिस सेशन",
        "AI प्रिस्क्रिप्शन रीडिंग (प्रति IPD मरीज़ प्रतिदिन 4 रीड शामिल)",
        "ओनर डैशबोर्ड, अप्रूवल व ऑडिट",
        "वार्ड अलर्ट व अर्ली-वॉर्निंग स्कोर",
      ],
    },
  },
  {
    id: "enterprise",
    name: "Enterprise",
    monthly: 19999,
    from: true,
    setup: 35000,
    credits: 8000,
    ipdUsage: true,
    recommended: false,
    forWhom: {
      en: "For larger and multi-department hospitals.",
      hi: "बड़े और मल्टी-डिपार्टमेंट अस्पतालों के लिए।",
    },
    features: {
      en: [
        "Everything in Professional",
        "Multi-department setup",
        "Priority support",
        "Custom onboarding",
      ],
      hi: [
        "Professional की हर सुविधा",
        "मल्टी-डिपार्टमेंट सेटअप",
        "प्राथमिकता सपोर्ट",
        "कस्टम ऑनबोर्डिंग",
      ],
    },
  },
];

export const planById = (id) => PLANS.find((p) => p.id === id);

export const inr = (n) => "₹" + Math.round(n).toLocaleString("en-IN");

/* Annual payment: 2 months free (pay 10, use 12) and setup fee waived. */
export const annualPerMonth = (plan) => Math.round((plan.monthly * 10) / 12);
export const annualBilled = (plan) => plan.monthly * 10;

/* Annual saving = 2 free months + the waived one-time setup fee. */
export const annualSaving = (plan) => plan.monthly * 2 + plan.setup;

export const SETUP_RANGE = { min: 2999, max: 35000 };

export const priceLabel = (plan, cycle) =>
  (plan.from ? "From " : "") + inr(cycle === "annual" ? annualPerMonth(plan) : plan.monthly);

export const priceLabelHi = (plan, cycle) =>
  inr(cycle === "annual" ? annualPerMonth(plan) : plan.monthly) + (plan.from ? " से" : "");

export const STARTING_PRICE = inr(PLANS[0].monthly);
export const HOSPITAL_START_PRICE = inr(PLANS[1].monthly);

export const CREDITS = [
  { en: "WhatsApp message", hi: "WhatsApp मैसेज", credits: "0.5" },
  { en: "SMS (OTPs and urgent updates only)", hi: "SMS (सिर्फ़ OTP व ज़रूरी अपडेट)", credits: "1" },
  { en: "WhatsApp broadcast, per recipient", hi: "WhatsApp ब्रॉडकास्ट, प्रति प्राप्तकर्ता", credits: "2" },
  { en: "AI prescription read beyond the included reads", hi: "शामिल रीड से ज़्यादा AI प्रिस्क्रिप्शन रीड", credits: "5" },
  { en: "Push notifications, email, QR and nurse scans", hi: "पुश नोटिफ़िकेशन, ईमेल, QR व नर्स स्कैन", credits: "Free" },
];

export const ADDONS = [
  { name: "PM-JAY Claim Kit", price: 1499, status: { en: "Available at launch", hi: "लॉन्च पर उपलब्ध" } },
  { name: "NABH Ready", price: 1999, status: { en: "Coming next", hi: "जल्द आ रहा है" } },
  { name: "Both together", price: 2999, status: { en: "Bundle", hi: "बंडल" } },
];

export const PATIENT_PAYMENTS = [
  {
    en: "UPI QR on bills and website: free, zero commission (recommended)",
    hi: "बिल व वेबसाइट पर UPI QR: मुफ़्त, शून्य कमीशन (अनुशंसित)",
  },
  { en: "Hospital's own Razorpay: no Atikxzio fee", hi: "अस्पताल का अपना Razorpay: कोई Atikxzio शुल्क नहीं" },
  {
    en: "Atikxzio Pay: flat convenience fee ₹10 per booking up to ₹1,000, ₹20 above (incl. GST); the hospital may absorb it",
    hi: "Atikxzio Pay: ₹1,000 तक की बुकिंग पर ₹10, उससे ऊपर ₹20 फ़्लैट सुविधा शुल्क (GST सहित); अस्पताल चाहे तो स्वयं वहन कर सकता है",
  },
];

export const COMING_NEXT = {
  en: "Coming next: Pharmacy, Lab and Inventory modules.",
  hi: "जल्द आ रहे हैं: फ़ार्मेसी, लैब और इन्वेंटरी मॉड्यूल।",
};

export const FOUNDING = {
  seats: 10,
  validUntil: { en: "31 March 2027", hi: "31 मार्च 2027" },
  perks: {
    en: [
      "₹15 per IPD patient-day / Day Care session instead of ₹20 for 12 months",
      "Priority onboarding and free data migration",
      "Ward tablet at cost",
      "A direct founder line",
    ],
    hi: [
      "12 महीने तक प्रति IPD मरीज़-दिन / डे केयर सेशन ₹20 की जगह ₹15",
      "प्राथमिकता ऑनबोर्डिंग और मुफ़्त डेटा माइग्रेशन",
      "वार्ड टैबलेट लागत मूल्य पर",
      "फ़ाउंडर से सीधी लाइन",
    ],
  },
  inReturn: {
    en: "In return: annual plan paid up front, a case study after 90 days, and two introductions.",
    hi: "बदले में: सालाना प्लान अग्रिम भुगतान, 90 दिन बाद एक केस स्टडी, और दो परिचय।",
  },
};
